import {
  RECEIPT_TRANSACTION_DOC_NUMBER_FILTER
} from "constants/ActionTypes";

const initialState = {
  docNumberFilter: ""
};

export default (state = initialState, action) => {
  switch (action.type) {
    case RECEIPT_TRANSACTION_DOC_NUMBER_FILTER:
      return {
        ...state,
        docNumberFilter: action.payload,
      };
    default:
      return state;
  }
};
